import { render, staticRenderFns } from "./Audit_log_viewer.vue?vue&type=template&id=1824db08&"
import script from "./Audit_log_viewer.vue?vue&type=script&lang=js&"
export * from "./Audit_log_viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports